import {registerLocale, setDefaultLocale} from 'react-datepicker'
import nb from 'date-fns/locale/nb'
registerLocale('nb', nb)
setDefaultLocale('nb')

// Imported from State/index
